<ng-container *ngIf="!isMaskedValue; else maskedInput">
  <div class="form-field__container">
    <p-multiSelect
      [options]="dropdownOptions"
      class="amenities-filters primeng-multiselect"
      [appendTo]="'body'"
      [resetFilterOnHide]="true"
      [placeholder]="!!placeholder ? placeholder : ('shared.select' | xTranslate)"
      selectedItemsLabel="{0} {{ 'recordsSearch.items' | xTranslate }}"
      displaySelectedLabel="false"
      maxSelectedLabels="1"
      [formControl]="fc"
      (onChange)="onChange($event)"
      [filterPlaceHolder]="'recordsSearch.search' | xTranslate"
    >
    </p-multiSelect>
    <ng-template let-option pTemplate="item">
      {{ option.value }}
    </ng-template>
  </div>
</ng-container>
<ng-template #maskedInput>
  <input matInput autocomplete="new-password" type="password" [disabled]="true" [value]="currentValue" />
</ng-template>
